import { useTranslation } from "react-i18next";
import { DatePickerControl, FileInputControl, InputControl } from "@/controls";
import { Column, Row, todayIso } from "@/ui-kit";

export const LicenseForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <InputControl label={t("label.license_number")} name="licenseIdNumber" />

      <Row gap="md" alignmentVertical="top">
        <Column fullWidth>
          <DatePickerControl
            label={t("label.issuance_date")}
            name="licenseIdIssuanceDate"
            maxDate={todayIso()}
          />
        </Column>
        <Column fullWidth>
          <DatePickerControl
            label={t("label.expiry_date")}
            name="licenseIdExpiryDate"
            minDate={todayIso()}
          />
        </Column>
      </Row>

      <FileInputControl
        label={t("label.license_front_image")}
        name="licenseFrontPicture"
      />

      <FileInputControl
        label={t("label.license_back_image")}
        name="licenseBackPicture"
      />
    </>
  );
};
